import { CommercialRentComp } from 'types/underwriting/income-approach';
import { compplexGraphqlApiUrl } from 'utils/config';

export const COMPPLEX_COMMERCIAL_LEASE_BY_ID_AND_VERSION = `
      query findLeaseByIdAndVersion($input: LeaseSearchByVersionInput!) {
        findLeaseByIdAndVersion(input: $input) {
          isLatestVersion
          deletedAt
        }
      }
    `;

const checkIfLatestCommercialRentCompVersion = async (input: { leaseId: string; version: number }) => {
  if (!compplexGraphqlApiUrl) {
    throw new Error('COMPPLEX_GRAPHQL_API_URL is not defined');
  }

  const response = await fetch(compplexGraphqlApiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: COMPPLEX_COMMERCIAL_LEASE_BY_ID_AND_VERSION,
      variables: { input },
      fetchPolicy: 'no-cache',
    }),
  });

  const data = await response.json();

  return data?.data.findLeaseByIdAndVersion || { isLatestVersion: false };
};

export const checkIfCommercialRentCompsAreLatestVersion = async (selectedComps: CommercialRentComp[]) => {
  const updates = selectedComps.map(async (commercialRentComp) => {
    const { leaseId, leaseVersionNumber } = commercialRentComp;
    const { isLatestVersion } = leaseVersionNumber
      ? await checkIfLatestCommercialRentCompVersion({
          version: leaseVersionNumber,
          leaseId,
        })
      : { isLatestVersion: false };

    return {
      ...commercialRentComp,
      isLatestVersion,
    };
  });

  const updatedComps = await Promise.all(updates);
  return updatedComps;
};
